<template>
  <basic-container>
    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft"> </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" @click="archiveType(scope.row)">
          档案信息
        </el-button>
        <!-- <el-button type="text" size="small" @click="datashow(scope.row)">
          动态数据展示
        </el-button> -->
        <el-button type="text" size="small" @click="datashow(scope.row)">
          动态数据达标
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        indexLabel: "序号",
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        selection: true,
        column: [
          {
            label: "设备开通率",
            prop: "name",
            // search: true
          },
          {
            label: "使用时长",
            prop: "mobile",
            // search: true
          },
          {
            label: "达标率",
            prop: "mobile",
            // search: true
          },
          {
            label: " 患者佩戴数据",
            type: "select",
            // search: true
          },
          {
            label: "报警事件统计",
            prop: "mobile",
            // search: true
          },
        ],
      },
      data: [],
    };
  },
  computed: {},
  methods: {
    searchReset() {
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      params.vipLevel = 2;
      params.channel = window.localStorage.getItem("channel");
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },

    onLoad(
      page,
      params = { vipLevel: 2, channel: window.localStorage.getItem("channel") }
    ) {
      console.log("test qqq");
      console.log(params);
    },

    archiveType(row) {
      console.log(row);
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/health/archiveType",
        query: parameter,
      });
    },
  },
};
</script>
